import { useSettingsStore } from '@/stores/settings'

/** Currency saved in Paramètres généraux (DH until the settings are loaded). */
export const currency = (): string => useSettingsStore().currency || 'DH'
